import {
  Avatar,
  Box,
  Divider,
  Fab,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import DashboardWrapper from "../../components/DashboardWrapper";
import { getSx } from "./style";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import CustomTextField from "../../components/Textfield";
import { useTheme } from "@emotion/react";
import { CometChatUsersWithMessages } from "@cometchat/chat-uikit-react";

export function loadingModalStyle(showModal) {
  return {
    display: showModal ? "flex" : "none",
    width: "100vw",
    height: "100vh",
    backgroundColor: "#393b39",
    position: "fixed",
    top: "0",
    left: "0",
    justifyContent: "center",
    alignItems: "center",
  };
}

const Chat = () => {
  const classes = getSx();
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <DashboardWrapper>
      <CometChatUsersWithMessages
        isMobileView={smScreen}
        usersConfiguration={{
          usersStyle: {
            // titleTextColor: "red"
          },
          audioCallIcon: false,
          listItemStyle: {
            // titleColor: "red"
          },
          avatarStyle: {
            // nameTextColor: 'red'
          },
          statusIndicatorStyle: {
            // background: "red"
          },
        }}
        usersWithMessagesStyle={
          {
            // background: 'red'
          }
        }
        messagesConfiguration={{
          hideMessageHeader: true,
          messageHeaderView: () => (
            <>hel</>
          ),
          messageHeaderConfiguration: {
            disableUsersPresence: true,
            hideBackButton: true,
            privateGroupIcon: false,
            protectedGroupIcon: false,
            subtitleView: false,
            listItemStyle: {
              // background: "red",
            },
            avatarStyle: {
              width: "28px",
              height: "28px",
              backgroundColor: "red",
            },
            statusIndicatorStyle: {
              // background: "red",
            },
            messageHeaderStyle: {
              // background: "red",
              privateGroupIconBackground: 'red',
            }
          },
          messagesStyle: {
            // background: "red",
            messageTextColor: "red",
            messageTextFont: "bold",
          },
          disableSoundForMessages: true,
          messageListConfiguration: {
            messageListStyle: {
              // TimestampTextColor: "red",
            },
            avatarStyle: { width: "28px", height: "28px", backgroundColor: "red" },
            disableReactions: true,
          },
        }}
      />
      <Grid
        container
        component={Paper}
        sx={classes.chatSection}
        style={{ display: "none" }}
      >
        <Grid item xs={3} sx={classes.borderRight500}>
          <List>
            <ListItem button key="RemySharp">
              <ListItemIcon>
                <Avatar
                  alt="Remy Sharp"
                  src="https://material-ui.com/static/images/avatar/1.jpg"
                />
              </ListItemIcon>
              {!smScreen && <ListItemText primary="John Wick"></ListItemText>}
            </ListItem>
          </List>
          <Divider />
          <Grid item xs={12} style={{ padding: "10px" }}>
            <CustomTextField
              id="outlined-basic-email"
              placeholder="Search"
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Divider />
          <List>
            <ListItem button key="RemySharp">
              <ListItemIcon>
                <Avatar
                  alt="Remy Sharp"
                  src="https://material-ui.com/static/images/avatar/1.jpg"
                />
              </ListItemIcon>
              {!smScreen && (
                <ListItemText primary="Remy Sharp">Remy Sharp</ListItemText>
              )}
              {/* {!smScreen && <ListItemText secondary="online" align="right"></ListItemText>} */}
            </ListItem>
            <ListItem button key="Alice">
              <ListItemIcon>
                <Avatar
                  alt="Alice"
                  src="https://material-ui.com/static/images/avatar/3.jpg"
                />
              </ListItemIcon>
              {!smScreen && <ListItemText primary="Alice">Alice</ListItemText>}
            </ListItem>
            <ListItem button key="CindyBaker">
              <ListItemIcon>
                <Avatar
                  alt="Cindy Baker"
                  src="https://material-ui.com/static/images/avatar/2.jpg"
                />
              </ListItemIcon>
              {!smScreen && (
                <ListItemText primary="Cindy Baker">Cindy Baker</ListItemText>
              )}
            </ListItem>
          </List>
        </Grid>
        <Grid item xs={9}>
          <List sx={classes.messageArea}>
            <ListItem key="1">
              <Grid container>
                <Grid item xs={9} sx={classes.sender}>
                  <ListItemText
                    align="left"
                    primary="Hey man, What's up ?"
                  ></ListItemText>
                  <ListItemText align="right" secondary="09:30"></ListItemText>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem key="2">
              <Grid container>
                <Grid item xs={9} sx={classes.receiver}>
                  <ListItemText
                    align="right"
                    primary="Hey, Iam Good! What about you ?"
                  ></ListItemText>
                  <ListItemText align="left" secondary="09:31"></ListItemText>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem key="3">
              <Grid container>
                <Grid item xs={9} sx={classes.sender}>
                  <ListItemText
                    align="left"
                    primary="Cool. i am good, let's catch up!"
                  ></ListItemText>
                  <ListItemText align="right" secondary="10:30"></ListItemText>
                </Grid>
              </Grid>
            </ListItem>
          </List>
          <Divider />
          <Box
            sx={{
              display: "flex",
              padding: "1rem",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <CustomTextField
              id="outlined-basic-email"
              placeholder="Type Something"
              fullWidth
            />
            <Fab
              color="info"
              aria-label="add"
              sx={{ height: "50px", width: "50px", padding: "1rem" }}
            >
              <SendOutlinedIcon sx={{ height: "24px", width: "24px" }} />
            </Fab>
          </Box>
        </Grid>
      </Grid>
    </DashboardWrapper>
  );
};

export default Chat;
